import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Box, Typography } from "@mui/material";
import { KeyboardArrowDownRounded } from "@mui/icons-material";
import useUser from "../../../../providers/user/user_provider";
import { green, greyEnabled, purple, red } from "../../../../theme/colors";

export default function StatusMenu({
  status,
  updatedStatus,
  onStatusChange,
  disabled = false,
}: {
  status: string;
  updatedStatus: string | null;
  onStatusChange: (status: string) => void;
  disabled?: boolean;
}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { hasPermission } = useUser();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Typography color={greyEnabled}>Status</Typography>
      {status === "Approved" || status === "Rejected" ? (
        <Box>
          <Typography
            fontWeight="600"
            color={status === "Approved" ? green : red}
          >
            {status}
          </Typography>
        </Box>
      ) : (
        <>
          <Button
            sx={{
              color: purple,
              textTransform: "capitalize",
              p: 0,
              m: 0,
              minWidth: 0,
              "&:hover": { bgcolor: "transparent" },
            }}
            id="basic-button"
            aria-controls={open ? "status-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            disabled={disabled || !hasPermission("services", "update")}
          >
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="body1" fontWeight={700} color={purple}>
                {updatedStatus || status}
              </Typography>
              <KeyboardArrowDownRounded sx={{ color: purple }} />
            </Box>
          </Button>
          <Menu
            id="status-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                mt: 0.5,
                borderRadius: 2,
                border: "1px solid #ECECEC",
                boxShadow: "0px 12px 28px -8px rgba(27, 0, 27, 0.18)",
              },
            }}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              disabled={status === "In Progress"}
              selected={status === "Pending" || status === "Modified"}
              onClick={() => {
                if (status === "Modified") {
                  onStatusChange("Modified");
                } else {
                  onStatusChange("Pending");
                }

                handleClose();
              }}
            >
              {status === "Modified" ? "Modified" : "Pending"}
            </MenuItem>
            <MenuItem
              selected={status === "In Progress"}
              onClick={() => {
                onStatusChange("In Progress");
                handleClose();
              }}
            >
              In Progress
            </MenuItem>
          </Menu>
        </>
      )}
    </div>
  );
}
